import { MOTION_EASING } from '../../utils/motion';

// The same sampled curve drives native linear() and compatible opacity keyframes.
const backdropEasingStops = [
  [0, 0],
  [9.09091, 0.157943],
  [18.1818, 0.414669],
  [27.2727, 0.63031],
  [36.3636, 0.780228],
  [45.4545, 0.875101],
  [54.5455, 0.931756],
  [63.6364, 0.964243],
  [72.7273, 0.982305],
  [81.8182, 0.992098],
  [90.9091, 0.997294],
  [100, 1],
] as const;

// Joy dialog motion candidate v1. Desktop measurements supplied by design.
// Durations are milliseconds; sizing and surface styling belong to the dialog.
export const DIALOG_RISE_MOTION = {
  enter: { distance: 100, duration: 400, easing: MOTION_EASING.settle, fadeDuration: 75 },
  exit: { distance: 50, duration: 150, easing: MOTION_EASING.accelerate, fadeDuration: 75, fadeDelay: 75 },
  backdrop: {
    color: '#222222',
    opacity: 0.4,
    enterDuration: 400,
    exitDuration: 250,
    easingStops: backdropEasingStops,
    easing: `linear(${backdropEasingStops.map(([percent, value]) => `${value} ${percent}%`).join(', ')})`,
  },
} as const;

export const getDialogMotionDurationScale = (scale = 1): number => (Number.isFinite(scale) && scale > 0 ? Math.min(scale, 10) : 1);
export const DIALOG_RISE_EXIT_DURATION = Math.max(DIALOG_RISE_MOTION.exit.duration, DIALOG_RISE_MOTION.backdrop.exitDuration);

// Compact companion to the full dialog: same timing, shorter travel, no backdrop.
export const MINI_DIALOG_RISE_MOTION = {
  enter: { ...DIALOG_RISE_MOTION.enter, distance: 24 },
  exit: { ...DIALOG_RISE_MOTION.exit, distance: 12 },
} as const;
